class OnyxProductTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

    this.dataset.initialized = 'true';
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index, true));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    const selectedIndex = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
    this.activate(selectedIndex, false);
    this.dataset.tabsReady = 'true';
  }

  activate(index, moveFocus) {
    this.tabs.forEach((tab, tabIndex) => {
      const isSelected = tabIndex === index;
      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
      this.panels[tabIndex].hidden = !isSelected;
    });

    if (moveFocus) this.tabs[index].focus();
  }

  onKeydown(event, index) {
    let nextIndex = index;
    const tablist = event.currentTarget.closest('[role="tablist"]');
    const isVertical = tablist?.getAttribute('aria-orientation') === 'vertical';
    const nextKey = isVertical ? 'ArrowDown' : 'ArrowRight';
    const previousKey = isVertical ? 'ArrowUp' : 'ArrowLeft';

    if (event.key === nextKey) nextIndex = (index + 1) % this.tabs.length;
    if (event.key === previousKey) nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    this.activate(nextIndex, true);
  }
}

if (!customElements.get('onyx-product-tabs')) {
  customElements.define('onyx-product-tabs', OnyxProductTabs);
}
